"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogopedPaymentHistoryService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class LogopedPaymentHistoryService {
    /**
     * @returns LogopedPaymentHistory
     * @throws ApiError
     */
    static logopedPaymentHistoryList() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/logoped_payment_history/',
        });
    }
}
exports.LogopedPaymentHistoryService = LogopedPaymentHistoryService;
